<template>
    <div class="content"
         @click="isShow">
        <div class="head">
            <div>
                <p class="title">作业详情</p>
                <p @click="back()"
                   class="back"></p>
                <p class="preview"
                   @click="preview(taskType)">作业预览</p>
            </div>
        </div>
        <div class="time_box"
             v-if='!is_active'>
            <!-- 活动不显示 -->
            <p class="jzTime">截止时间：{{ endDate }}</p>
            <p class="endTime"
               v-if="flagBoon">已截止</p>
        </div>
        <div class="tabs"
             v-if="!is_active">
            <!-- 活动加 -->
            <div>
                <p @click="tab(1)"
                   :class="[tabNum == 1 ? 'check' : 'nocheck']">完成情况</p>
            </div>
            <div></div>
            <div>
                <p @click="tab(2)"
                   :class="[tabNum == 2 ? 'check' : 'nocheck']">作业报告</p>
            </div>
        </div>
        <div class="tabs marginTop"
             v-if="is_active">
            <!-- 活动加 -->
            <div style="width:100%;">
                <p class="tabNum">完成情况</p>
            </div>
        </div>
        <template v-if="loading">
            <!-- 期末大检查 -->
            <!-- <analyze ref="analyze" :finish_num="finish" :average="average" :anums="anums" :bnums="bnums" :cnums="cnums"
                :dnums="dnums" v-if="tabNum == 1&& (testType==9||testType==8||testType==7)"></analyze> -->
            <results v-if="tabNum == 1"
                     :taskType="taskType"
                     :testType="testType"
                     :finishlist="finshList"
                     :finish="finish"
                     :unfinish="unfinish"
                     :unspec="unspec"
                     :sid="sid"
                     :classid="this.classId"
                     :taskid="this.taskId"
                     :city="city"
                     :endDate='endDate'
                     :wrong_num="wrong_num"></results>
            <reports v-if="tabNum == 2"
                     :taskType="this.taskType"
                     :testType="testType"
                     :knows="knows"
                     :asksList="asksList"
                     :sid="this.sid"
                     :classid="this.classId"
                     :taskid="this.taskId"></reports>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>
        <!-- 作业已到完成时间且减去补交人数外有超过5人完成 -->
        <div class="mathshare"
             v-if="finshList.length>0&&!is_active">
            <div class="bottom_share clearfix">
                <div :class='[(is_active||flagBoon)&finish>0?"bottom_share-box1":"bottom_share-box2"]'>
                    <div class="reward_box"
                         v-if='(is_active||flagBoon)&finish>0'>
                        <div @click="reward"><img src="./img/test_jp.png">奖励和评语</div>
                    </div>
                    <div class="share_box">
                        <div @click="mathshare"><img src="./img/test_fx.png">分享报告给家长</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mathshare"
             v-if="is_active">
            <div class="bottom_share clearfix">
                <div class="bottom_share-box2">
                    <div class="share_box">
                        <div @click="shareHD"><img src="./img/test_fx.png">分享学生完成情况</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import loadingS from 'SRC/components/base/tealoading.vue';
import headers from 'SRC/components/base/header.vue'
// import analyze from 'SRC/components/activity/schoolopens/tea/analyze.vue';
import results from 'VIEWS/math/inspect/resultList.vue'
import reports from 'VIEWS/math/inspect/reportList.vue'

export default {
    data () {
        return {
            sid: this.$route.params.sid, //21小学22初中
            taskId: this.$route.params.taskid, //作业id
            classId: this.$route.params.classid, //班级id
            taskType: this.$route.params.taskType, //作业类型1课前2课后3课外
            testType: this.$route.params.testType, //9期中大检查  8期末大检查  7开学大检查
            task_name: this.$route.query.task_name,
            begin_date: this.$route.query.begin_date,
            mid: this.$route.query.mid || "",
            taskList: [],
            tabNum: this.$store.state.tabNum,
            finshList: [], //所有学生列表
            finish: null, //完成学生
            unfinish: null, //未完成
            asksList: [], //错误率数据
            knows: [],
            flagBoon: false, //截止时间
            city: 1111,
            endDate: null,
            students: null,
            unspec: null,
            loading: false,
            shareShow: false, //通知家长查看按钮显示（完成作业不包含补交人数超过5人）
            is_active: Number(this.$route.query.is_active) || 0, //期中活动
            wrong_num: 0,
            average: null,
            anums: null,
            bnums: null,
            cnums: null,
            dnums: null,
        }
    },
    created () {
        this.taskType = this.taskType;
        this.testType = this.testType;
        if (this.tabNum == 2) {
            this.getlist()
            this.tab(2)
        } else {
            this.getlist()
        }
    },
    destroyed () { },
    methods: {
        isShow () {
            if (this.$refs.analyze) { this.$refs.analyze.isShow = false };
        },
        back () {
            this.$store.commit("setTabNum", 1);
            this.$router.go(-1)
        },
        preview (taskType) { //作业预览
            if (taskType != 1) {
                this.$router.push("/preview/task/" + this.sid + "/" + this.taskId + "/" + this.testType)
            } else {
                this.$router.push("/preview/video/" + this.taskId)
            }
        },
        tab (num) { //切换
            this.loading = false;
            this.tabNum = num;
            let taskType = this.taskType;
            let testType = this.testType;
            this.$store.commit("setTabNum", num);
            if (this.tabNum == 2) {
                if (taskType == 1) {
                    this.$http.post(API_URL_TASK_API + '/maths/check/video/report', {
                        "message_id": this.taskId,
                        "unit_class_id": this.classId
                    }).then(res => {
                        this.loading = true;
                        if (res.data.response == 'ok') {
                            this.knows = res.data.data;
                        }
                        this.$nextTick(function () {
                            MathJax.Hub.Typeset(document.body);
                        })
                    })
                } else {
                    if (testType == 4) {
                        this.$http.post(API_URL_TASK_API + '/maths/check/quick/check/report', {
                            "message_id": this.taskId,
                            "unit_class_id": this.classId
                        }).then(res => {
                            this.loading = true;
                            if (res.data.response == 'ok') {
                                this.asksList = res.data.data;
                                this.$nextTick(function () {
                                    MathJax.Hub.Typeset(document.body);
                                })
                            }
                        })
                    } else {
                        this.$http.post(API_URL_TASK_API + '/maths/check/task/report', {
                            "message_id": this.taskId,
                            "unit_class_id": this.classId,
                            "sid": this.sid
                        }).then(res => {
                            this.loading = true;
                            if (res.data.response == 'ok') {
                                this.asksList = res.data.data.asks;
                                this.knows = res.data.data.knows;
                                this.$nextTick(function () {
                                    MathJax.Hub.Typeset(document.body);
                                })
                            }
                        })
                    }
                }
            } else {
                this.getlist();
            }
        },
        getlist () {
            let url = '/maths/check/task/detail';
            // 开会大检查
            if (this.testType == 7) {
                url = '/maths/check/task/kxdjc_detail';
            }
            // 期末大检查
            if (this.testType == 8) {
                url = '/maths/check/task/qm2020_detail';
            }
            // 期中大检查
            if (this.testType == 9) {
                url = '/maths/check/task/qz2021_detail';
            }
            let that = this;
            this.$http.post(API_URL_TASK_API + url, {
                "message_id": that.taskId,
                "sid": that.sid,
                "unit_class_id": that.classId
            }).then(res => {
                if (res.data.response == 'ok') {
                    this.loading = true;
                    let data = res.data.data;
                    this.finshList = data.students;
                    this.finish = data.finish_num;
                    this.unfinish = data.unfinished_num;
                    this.unspec = data.special_num;
                    this.endDate = data.end_date;
                    this.wrong_num = data.wrong_num || 0;
                    this.average = data.average;
                    this.anums = data.anums;
                    this.bnums = data.bnums;
                    this.cnums = data.cnums;
                    this.dnums = data.dnums;
                    localStorage.setItem('endDate', this.endDate);
                    if (data.is_end == 1) {
                        this.flagBoon = true;
                    } else {
                        this.flagBoon = false;
                    }
                    let finishStuNum = 0;
                    this.finshList.forEach(stu => {
                        if (stu.status == 1) {
                            finishStuNum++;
                        }
                    })
                    if (finishStuNum >= 5) {
                        this.shareShow = true;
                    }
                }
            })
        },
        mathshare () { //分享
            this.$router.push("/base/shareToParent/" + this.classId + "/" + this.taskId + "/" + this.taskType + "/" +
                this.testType + '/' + this.sid + '?is_active=' + this.is_active);
        },
        shareHD () {
            if (this.is_active == 2) {
                this.$router.push(`/activity/2020winter/tea/sharePreview?unit_class_id=${this.classId}&message_id=${this.mid ? this.mid : this.taskId}&sid=${this.sid}`);
            } else {
                this.$router.push(`/activity/2021summer/tea/sharePreview?unit_class_id=${this.classId}&message_id=${this.taskId}&sid=${this.sid}`);
            }
        },
        sharestus () {
            this.$router.push(
                `/activity/winter/tea/sharePreview?unit_class_id=${this.classId}&message_id=${this.taskId}&sid=${this.sid}`
            ); //gsd寒假活动加
        },
        reward () {
            if (this.testType == 1 & this.taskType == 1) {
                this.$router.push("/tea/testreward/" + this.sid + "/" + this.taskId + "/" + this.classId +
                    "?remark=1");
            } else {
                this.$router.push("/tea/testreward/" + this.sid + "/" + this.taskId + "/" + this.classId);
            }
        }
    },
    components: {
        headers,
        results,
        reports,
        loadingS,
        // analyze
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.content {
    width: 100vw;
    background: #f5f9ff;
    overflow-x: hidden;
    min-height: 100%;
    position: relative;
}

.head {
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;

    div {
        width: 100%;
        height: 96px / $ppr;
        position: relative;

        .title {
            width: 100%;
            height: 96px / $ppr;
            text-align: center;
            line-height: 96px / $ppr;
            color: #fff;
            font-size: 34px / $ppr;
        }

        .back {
            width: 18px / $ppr;
            height: 36px / $ppr;
            background: url(../img/choose_back.png) no-repeat;
            background-size: 100%;
            position: absolute;
            top: 30px / $ppr;
            left: 24px / $ppr;
        }

        .preview {
            position: absolute;
            top: 30px / $ppr;
            right: 24px / $ppr;
            font-size: 28px / $ppr;
            z-index: 10;
            color: #fff;
        }
    }
}

.time_box {
    width: 100%;
    height: 96px / $ppr;
    margin-top: 96px / $ppr;
    background: #5e89ef;

    .jzTime {
        padding-left: 24px / $ppr;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        color: #fff;
        font-size: 30px / $ppr;
        float: left;
    }

    .endTime {
        float: right;
        font-size: 30px / $ppr;
        color: #dde7fd;
        margin-right: 24px / $ppr;
        line-height: 96px / $ppr;
    }
}

.tabs {
    width: 100%;
    height: 96px / $ppr;
    margin-bottom: 24px / $ppr;
    background-color: #fff;
    display: flex;
    position: relative;
    z-index: 2;

    &.marginTop {
        margin-top: 2.4rem;
    }

    div {
        float: left;
        font-weight: bold;

        p {
            font-weight: 700;
            margin: 0 auto;
            width: 144px / $ppr;
            height: 93px / $ppr;
            line-height: 96px / $ppr;
            text-align: center;
            font-size: 30px / $ppr;
        }
    }

    div:nth-child(1) {
        width: 360px / $ppr;
        height: 96px / $ppr;
    }

    div:nth-child(2) {
        width: 1px;
        height: 64px / $ppr;
        background: #dcdcdc;
        margin-top: 19px / $ppr;
    }

    div:nth-child(3) {
        margin-left: -1px;
        width: 360px / $ppr;
        height: 96px / $ppr;
    }
}

.check {
    border-bottom: 4px / $ppr solid #5e89ef;
    color: #5e89ef;
}

.nocheck {
    color: #333;
}

.noresources {
    width: 100%;
    height: 300px / $ppr;

    p {
        line-height: 300px / $ppr;
        text-align: center;
    }
}

.mathshare {
    width: 100%;
    height: 97px / $ppr;
    margin-top: 20px / $ppr;

    .bottom_share {
        width: 100%;
        position: fixed;
        bottom: 0;
        color: #fff;
        font-size: 30px / $ppr;
        line-height: 97px / $ppr;
        text-align: center;
    }

    .bottom_share-box1 {
        .share_box,
        .reward_box {
            width: 50%;
        }
    }

    .bottom_share-box2 {
        .share_box {
            width: 100%;
        }
    }

    .share_box {
        background: #5e89ef;
        float: right;
    }

    .reward_box {
        background: #ff6600;
        float: left;
    }

    .reward {
        width: 100%;
        background: #ff6600;

        p {
            width: 160px / $ppr;
            margin: 0 auto;
            line-height: 97px / $ppr;
            padding-left: 50px / $ppr;
            position: relative;
        }

        img {
            display: block;
            position: absolute;
            width: 40px / $ppr;
            top: 28px / $ppr;
            left: 0;
        }
    }

    .share_box div,
    .reward_box div {
        position: relative;

        // padding-left:50px/$ppr;
        img {
            display: inline-block;
            width: 40px / $ppr;
            position: relative;
            top: 8px / $ppr;
            margin-right: 10px / $ppr;
        }
    }

    .reward_box div img {
        // left:70px/$ppr;
    }
}

.sharestus {
    width: 100%;
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    text-align: center;
    font-size: 30px / $ppr;
    color: #fff;
    background: #5e89ef;
}
</style>
